<template>
  <div>
    <px-view-header title="Grupos de fornecedores" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-fornecedor-gestao-grupos-listagem-header :on-click-refresh="onClickRefresh"
                                     :on-change-filter="onChangeFilter"
                                     @change="onChangeFilter"/>
    <px-fornecedor-gestao-grupos-lista :fornecedor-gestao-grupos="fornecedorGestaoGrupos"
                           :loading="loading"
                           :on-change-options="onChangeOptions"
                           :options-list="optionsList"
                           :footer-options="footerOptions"
                           @remove="onRemove"
                           @update="onClickRefresh"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-fornecedores-gestao-grupos/actions.type';
import FornecedorGestaoGruposListagemHeader from '@/modules/gestao-fornecedor-grupos/FornecedorGestaoGruposListagemHeader.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import FornecedorGestaoGruposService from '@/modules/gestao-fornecedor-grupos/fornecedor-gestao-grupos-service';
import FornecedorGestaoGruposLista from '@/modules/gestao-fornecedor-grupos/FornecedorGestaoGruposLista.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      fornecedorGestaoGrupos: {
        content: [],
        total: 0,
      },
      optionsList: {},
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de fornecedores' },
        { text: 'Grupos de fornecedores' },
      ],
    };
  },
  computed: {
    ...mapGetters('listagemFornecedoresGestaoGrupos', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemFornecedoresGestaoGrupos', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getFornecedoresGestaoGrupos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getFornecedoresGestaoGrupos();
    },
    onClickRefresh() {
      this.getFornecedoresGestaoGrupos();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getFornecedoresGestaoGrupos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return FornecedorGestaoGruposService.getFornecedoresGestaoGrupos({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.fornecedorGestaoGrupos = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
    onRemove(fornecedorGestaoGrupos) {
      this.loading = true;
      return FornecedorGestaoGruposService.remove(fornecedorGestaoGrupos.id)
        .then(() => {
          this.$toast('Grupo removido', { color: 'success' });
          return this.getFornecedoresGestaoGrupos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxFornecedorGestaoGruposLista: FornecedorGestaoGruposLista,
    pxFornecedorGestaoGruposListagemHeader: FornecedorGestaoGruposListagemHeader,
  },
};
</script>
